import { createReducer, on } from "@ngrx/store";
import * as OrganizationActions from "./organization.actions";
import type { OrganizationState } from "./organization.models";

export const initialState: OrganizationState = {
  data: null,
  allData: [],
  error: null,
  message: null,
  success: false,
  validationError: []
};

export const organizationReducer = createReducer(
  initialState,

  on(OrganizationActions.OrganizationGetSuccess, (state, payload) => ({
    ...state,
    data: payload.organization,
    error: null,
    message: "Organization fetched successfully",
    success: true,
    validationError: []
  })),

  on(OrganizationActions.OrganizationGetFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(OrganizationActions.OrganizationListSuccess, (state, { organizations }) => ({
    ...state,
    allData: organizations,
    error: null,
    message: "Organizations fetched successfully",
    success: true,
    validationError: []
  })),

  on(OrganizationActions.OrganizationListFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(OrganizationActions.OrganizationCreateSuccess, (state, { message }) => ({
    ...state,
    error: null,
    message,
    success: true,
    validationError: []
  })),

  on(OrganizationActions.OrganizationCreateFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(OrganizationActions.OrganizationUpdateSuccess, (state, { message }) => ({
    ...state,
    error: null,
    message,
    success: true,
    validationError: []
  })),

  on(OrganizationActions.OrganizationUpdateFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(OrganizationActions.OrganizationGenerateCredentialsSuccess, (state) => ({
    ...state,
    error: null,
    success: true,
    validationError: []
  })),

  on(OrganizationActions.OrganizationGenerateCredentialsFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(OrganizationActions.OrganizationSetActiveSuccess, (state, { message }) => ({
    ...state,
    error: null,
    message,
    success: true,
    validationError: []
  })),

  on(OrganizationActions.OrganizationSetActiveFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(OrganizationActions.OrganizationValidationError, (state, { validationErrors }) => ({
    ...state,
    validationError: validationErrors,
    error: null,
    message: null,
    success: false
  }))
);
